import { c as _c } from "react/compiler-runtime";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { SingleWaveDrop } from "../waves/drop/SingleWaveDrop";
interface Props {
  readonly drop: ExtendedDrop;
  readonly onClose: () => void;
}
const BrainDesktopDrop: React.FC<Props> = t0 => {
  const $ = _c(3);
  const {
    drop,
    onClose
  } = t0;
  let t1;
  if ($[0] !== drop || $[1] !== onClose) {
    t1 = <div className="tw-absolute tw-inset-0 tw-z-1000 tailwind-scope"><SingleWaveDrop drop={drop} onClose={onClose} /></div>;
    $[0] = drop;
    $[1] = onClose;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default BrainDesktopDrop;